module.exports = __webpack_public_path__ + "img/cust.3f3fc20e.png";